import moment from 'moment';

const isMonthYearCurrent = (date) => {
  // compares month/year to current month/year. if either is different, returns false.

  return moment(date).format('MM YYYY') === moment().format('MM YYYY');
};

export default isMonthYearCurrent;
